import React from 'react'
import "./footer.css"
import logo from "../../assets/imagetype-and-logo.svg"

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container">
            <object className='imagetype__and__logo' data={logo} width="150" height='auto'/>
            <div className='footer__div__copy'>  
                <span className="footer__copy">© Copyright 2024 | Emanuel Pro Paiting  | Website Design by Homi</span>
            </div>  
            <ul className="footer__list">
                <li>
                    <a href="#header" className="footer__link">About</a>
                </li>
            </ul>
          {/**  <div className="footer__social">
                <a href="https://www.instagram.com/homicln/" className="footer__social-link" target="_blanck">
                <i class="uil  uil-instagram"></i>
                </a>
                
                <a href="https://www.facebook.com/horacio.hmi" className="footer__social-link" target="_blanck">
                    <i class="uil  uil-facebook"></i>
                </a>
            </div> */}
        </div>
    </footer>
  )
}

export default Footer
